import React from 'react'
import { CSVLink } from "react-csv";
import { Transaction } from '../../services/openapi';
import { ApiResult } from '../../services/openapi/core/ApiResult';
 

type CsvExportProps = {
    className: string,
    style: Record<string, string>,
    filename: string,
    separator: string,
    headers: {label: string, key:string }[],
    onGetData: () => Promise<ApiResult>
}

type CsvExportState = {
    collection: [],
    loading: boolean
}

export default class CsvExport extends React.Component<CsvExportProps, CsvExportState> {
    constructor(props: CsvExportProps) {
        super(props);

        this.state = {
            collection: [],
            loading: false
        };
    }

    getData = () => {
        if (!this.state.loading) {
            this.setState({
                loading: true
            });
            this.props.onGetData()
                .then((result) => {
                    let r = result.body;
                    if (Array.isArray(result.body)) {
                        const array = Array.from(result.body);
                        if (array.length === 1 && Array.isArray(array[0])) {
                            r = array[0];
                            if (r.length === 1 && Array.isArray(r[0])) {
                                r = r[0];
                            }
                        }
                    }

                    this.setState({
                        collection: r,
                        loading: false
                    });
                    var btn = document.getElementById("cvsLink") as HTMLAnchorElement;
                    btn.click();
                }).catch(() => {
                    this.setState({
                        loading: false
                    });
                });
        }
    }    

    render() {
        const { loading } = this.state;
        return (
            <>
                <button
                    onClick={this.getData}
                    className={this.props.className}
                    style={this.props.style}
                >
                    {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : undefined}
                    &nbsp;Download
                </button>
                {this.state.collection && (
                    <CSVLink
                        id="cvsLink"
                        headers={this.props.headers}
                        data={this.state.collection}
                        filename={this.props.filename}
                        separator={this.props.separator}
                    />
                )}
            </>);
    }
}